export default function optionReducer(option, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "announcement": {
      return {
        ...option,
        [action.type]: action.value ? action.soundStore.list.find((sound) => sound.id === action.value) : null,
      };
    }
    case "forceCallerId":
      return { ...option, [action.type]: action.value ? action.value : null };

    default:
      return { ...option, [action.type]: action.value };
  }
}
